import { api } from './client';

/** Bandeja de aprobaciones del negocio activo (estándar Codeus). Prefijo: /api/aprobaciones */

export type EstadoAprobacion = 'pendiente' | 'aprobando' | 'aprobada' | 'rechazada' | 'fallida' | 'vencida' | 'interrumpida';

export interface Aprobacion {
  id: string;
  area: string;
  areaNombre: string;
  topeId: string;
  tope: string;
  metodo: string;
  url: string;
  cuerpoJson: unknown;
  pedido: number;
  limite: number;
  motivo: string | null;
  estado: EstadoAprobacion;
  resueltoAt: string | null;
  resultadoJson: unknown;
  createdAt: string;
  /** Sin `email` si el rol de quien mira oculta el correo. */
  solicitante: { name: string | null; email?: string };
  resueltoPor: { name: string | null; email?: string } | null;
  rolDeNegocio: { nombre: string } | null;
  mia: boolean;
  puedoResolver: boolean;
}

export const listar = (estado: 'pendiente' | 'resueltas') =>
  api.get<{ areasQueApruebo: string[]; aprobaciones: Aprobacion[] }>(`/api/aprobaciones?estado=${estado}`);
export const aprobar = (id: string) => api.post<{ id: string; estado: 'aprobada' }>(`/api/aprobaciones/${id}/aprobar`, {});
export const rechazar = (id: string, motivo?: string) => api.post<{ id: string; estado: 'rechazada' }>(`/api/aprobaciones/${id}/rechazar`, { motivo });
